import { useRef, useState } from "react";
import Input from "./common/input";
import Modal from "./common/modal";
import PageHeading from "./common/pageHeading";
import Textarea from "./common/textarea";
import { Turnstile } from '@marsidev/react-turnstile'
import toast from "react-hot-toast";
import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";

const ContactForm = () => {
    const [formValues, setFormValues] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        ignore: "",
    });
    const [error, setError] = useState("");

    const turnstileRef = useRef(null);
    const navigate = useNavigate();

    const handleChange = (event) => {
        setFormValues({
            ...formValues,
            [event.target.name]: event.target.value
        });
    }

    const submitRequest = async (e) => {
        e.preventDefault();
        const URL = "https://n6b04cw1tb.execute-api.us-west-2.amazonaws.com/contact-us";
        const { name, email, phone, message, ignore } = formValues;

        const token = turnstileRef.current?.getResponse()

        const nameRe = /[A-Za-z]{1}[A-Za-z]/;
        if (!nameRe.test(name)) {
            setError("Name cannot be less than 2 characters");
            return;
        }
        if (email == "") {
            setError("Please enter your email address");
            return;
        }

        var emailRe = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,6})?$/;
        if (!emailRe.test(email)) {
            setError("Please enter a valid email address");
            return;
        }

        setError("");

        const data = {
            name,
            phone,
            email,
            message,
            ignore,
            token
        };

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Access-Control-Allow-Origin", "*");

        const response = await fetch("https://n6b04cw1tb.execute-api.us-west-2.amazonaws.com/contact-us", {
            method: "POST",
            body: JSON.stringify(data)
        });

        turnstileRef.current?.reset()

        if (!response.ok) {
            toast.error("Unable to submit");
        } else {
            toast.success("Successful");
            navigate("/contact");
        }
    }

    return <>
        <div className="container mx-auto relative p-2">
            <PageHeading>Demo Request Form</PageHeading>
            {error !== "" && <div className="bg-red-200 border border-1 border-red-600 px-4 py-2 rounded-md mb-2 flex items-center gap-2">
                <div><FontAwesomeIcon icon={faWarning} className="text-red-800 text-2xl" /></div>
                <div className="flex-1 text-red-800">{error}</div>
            </div>}
            <section className="space-y-5 text-base lg:text-lg 2xl:text-2xl text-justify "></section>
            <form action="https://n6b04cw1tb.execute-api.us-west-2.amazonaws.com/contact-us">
                <div className="flex flex-col gap-2">
                    <Input
                        type="text"
                        name="name"
                        label="Name"
                        value={formValues.name}
                        onChange={handleChange}
                        required
                    />
                    <Input
                        type="text"
                        name="email"
                        label="Email"
                        value={formValues.email}
                        onChange={handleChange}
                        required
                    />
                    <Input
                        type="text"
                        name="phone"
                        label="Phone Number"
                        value={formValues.phone}
                        onChange={handleChange}
                    />
                    <Textarea
                        type="text"
                        name="message"
                        label="Message"
                        rows={"3"}
                        value={formValues.message}
                        onChange={handleChange}
                        required
                    />
                    <input type="hidden" name="ignore" value={formValues.ignore} onChange={handleChange} />
                    <div className="text-center">
                        <Turnstile
                            ref={turnstileRef}
                            siteKey='0x4AAAAAAEHBBLuWPVShWWSW'
                        // siteKey="1x00000000000000000000AA"
                        />
                        <div className="flex justify-center items-center gap-2">

                            <button
                                className="rounded-md bg-indigo-50 border border-indigo-200 text-indigo-600 cursor-pointer px-2 py-1 hover:bg-indigo-100 hover:text-indigo-800"
                                onClick={submitRequest}
                            >
                                Submit
                            </button>
                            <NavLink
                                className="rounded-md bg-gray-50 border border-gray-200 text-gray-600 cursor-pointer px-2 py-1 hover:bg-gray-100 hover:text-gray-800"
                                to="/contact"
                            >
                                Cancel
                            </NavLink>
                        </div>
                    </div>
                </div>
            </form>
        </div></>
}

export default ContactForm;